import { Redirect, Route, Switch } from 'quartz-routing/react-router';
import AppLayout from '../layouts/AppLayout';
import { useCasesQueryParamKey } from '../v2/hsoc/use-case-positioning/useCaseConstants';
import { getUseCasesByPage } from '../v2/hsoc/use-case-positioning/useCaseUtils';
import { HubSpotOnCreditsPage } from './loadablePages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubSpotOnCreditsRoutes = () => {
  return /*#__PURE__*/_jsx(AppLayout, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        component: HubSpotOnCreditsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/:page",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => {
          const searchParams = new URLSearchParams(location.search);
          const useCases = getUseCasesByPage(page);
          for (const useCase of useCases) {
            searchParams.append(useCasesQueryParamKey, useCase);
          }
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              search: searchParams.toString(),
              pathname: '/'
            })
          });
        }
      })]
    })
  });
};